import React, { useState, useEffect, useRef, useCallback } from 'react';

import { cider } from '../../../../common/config';
import Cider from '../../../../common/components/glb/Cider';
import useMediaStore from '../../../../common/store/useMediaStore';
import useFlavorStore from '../../../../common/store/useFlavorStore';
import useAnimation from './useAnimation';

const Scene = () => {
  /**
   * Hooks
   */
  const media = useMediaStore(useCallback(state => state.media, []));
  const flavor = useFlavorStore(useCallback(state => state.flavor, []));

  const outer = useRef<THREE.Group>(null);
  const inner = useRef<THREE.Group>(null);

  const [localFlavor, setLocalFlavor] = useState(flavor);

  const [rotateOut, rotateIn] = useAnimation(outer, inner);

  useEffect(() => {
    if (localFlavor !== flavor) {
      rotateOut.current?.play(0).eventCallback("onComplete", () => {
        setLocalFlavor(flavor);
        rotateIn.current?.play(0);
      });
    }
  }, [flavor, rotateIn, rotateOut]);

  /**
   * Render
   */
  return (
    <group ref={outer}>
      <group ref={inner}>
        <Cider
          flavor={localFlavor}
          scale={cider.scale[media]}
          rotation={[0.1, 0, 0.1]}
        />
      </group>
    </group>
  );
}

export default Scene;